<div
	*ngIf="editMode"
	class="overlay bg-black opacity-30 fixed top-0 left-0 w-screen h-screen z-30"
></div>
<div class="w-full">
	<div class="flex justify-between text-dark-grey py-24px">
		<p class="my-auto">
			{{ 'ORGANIZATION.ORGANIZATION_STATUS.ORG_INFO' | translate }}
		</p>
		<div
			*ngIf="!editMode"
			(click)="changeEditMode()"
			class="flex text-[#009EF7] mx-6 cursor-pointer"
		>
			<img class="w-5 max-h-5 mx-1" src="assets/images/edit-blue.svg" alt="" />

			<p class="my-auto">{{ 'ACTIONS.EDIT' | translate }}</p>
		</div>
	</div>
	<div
		class="flex flex-col custom-shadow gap-[14px] rounded-12px bg-off-white  {{
			editMode ? 'z-40' : ''
		}} relative  "
	>
		<form>
			<div
				[formGroup]="orgInfoForm"
				class="w-full rounded-[12px] bg-off-white drop-shadow shadow-lg"
			>
				<div class="p-24px">
					<div class="flex justify-between">
						<div class="flex items-center mb-[12px]">
							<img
								class="w-[52px] h-[52px] ltr:mr-[12px] rtl:ml-[12px] rounded-full"
								onerror="this.src='assets/images/logo empty state.svg'"
								[src]="attachmentUrl + '/' + organizationData.logoUrl"
								alt=""
							/>
							<p class="mt-2">
								{{ 'ORGANIZATION.ORGANIZATION_STATUS.ORG_LOGO' | translate }}
							</p>
						</div>

						<div class="flex mb-2" *ngIf="editMode">
							<button
								*ngIf="
									organizationData.logoUrl !=
										'/Static/Logo/Service Provider Logo.png' ||
									organizationData.logoUrl == null
								"
								(click)="organizationData.logoUrl = null"
								class="text-red-error px-24px mb-2"
							>
								{{ 'ACTIONS.DELETE_LOGO' | translate }}
							</button>
							<button
								href=""
								class="text-dark-grey border mb-2 px-24px rounded"
								(click)="uploadImage('logo')"
							>
								{{ 'ORGANIZATION.ORGANIZATION_STATUS.UP_LOGO' | translate }}
							</button>
						</div>
					</div>

					<mat-form-field
						*ngIf="editMode"
						[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
						class="w-full mb-[16px]"
						appearance="outline"
						floatLabel="always"
					>
						<mat-label class="text-dark-grey">{{
							'GENERAL_LABELS.COUNTRY' | translate
						}}</mat-label>
						<mat-select
							class="text-medium-gray px-3"
							formControlName="countryId"
							[compareWith]="compareWith"
							required
						>
							<mat-option
								class="my-2"
								*ngFor="let country of countries"
								[value]="country.id"
							>
								<img
									class="inline ltr:mr-2 rtl:ml-2 w-[40px]"
									[src]="attachmentUrl + country.flagUrl"
									alt="icon"
								/>
								<p class="inline-block">
									{{
										translate.currentLang == 'en'
											? country.name.en
											: country.name.ar
									}}
								</p>
							</mat-option>
						</mat-select>
					</mat-form-field>
					<p
						*ngIf="editMode && organizationData?.hasAppointments"
						class="py-0 pb-1 mt-0 my-3"
					>
						{{
							'ORGANIZATION.ORGANIZATION_STATUS.CHANGE_COUNTRY_HINT' | translate
						}}
					</p>
					<div
						*ngIf="!editMode"
						class="w-full max-h-[73px] p-[17px] border-solid border-b-2"
					>
						<p class="mb-0 pb-0 text-[#6E7191]">
							{{ 'GENERAL_LABELS.COUNTRY' | translate }}
						</p>
						<p class="viewMode text-font-16">
							{{
								translate.currentLang == 'ar'
									? organizationData?.country?.name?.ar
									: organizationData?.country?.name?.en
							}}
						</p>
					</div>

					<mat-form-field
						*ngIf="editMode"
						[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
						class="w-full mb-[16px]"
						appearance="outline"
						floatLabel="always"
					>
						<mat-label class="text-dark-grey">{{
							'ORGANIZATION.ORGANIZATION_STATUS.BUSINESS_NAME' | translate
						}}</mat-label>
						<input
							type="text"
							matInput
							placeholder="{{
								'ORGANIZATION.ORGANIZATION_STATUS.BUSINESS_NAME' | translate
							}}"
							formControlName="businessName"
							maxlength="150"
							(change)="checkBusinessNameExist()"
						/>
						<img
							*ngIf="getController('businessName')?.value && editMode"
							(click)="getController('businessName').setValue('')"
							class="cursor-pointer absolute ltr:right-[7px] rtl:left-0 inline-block top-[15px]"
							src="./assets/images/close-square.svg"
							alt=""
						/>

						<mat-error>
							<validation-message
								[controller]="getController('businessName')"
								controller_name="ORGANIZATION.ORGANIZATION_STATUS.BUSINESS_NAME"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>

					<div
						*ngIf="!editMode"
						class="w-full max-h-[73px] p-[17px] border-solid border-b-2"
					>
						<p class="mb-0 pb-0 text-[#6E7191]">
							{{ 'ORGANIZATION.ORGANIZATION_STATUS.BUSINESS_NAME' | translate }}
						</p>
						<p class="viewMode text-font-16">
							{{ organizationData?.businessName }}
						</p>
					</div>
					<span
						*ngIf="
							businessNameExist &&
							editMode &&
							getController('businessName').value
						"
						class="whitespace-nowrap text-font-12 mt-[-10px] block text-red-error mb-[10px] px-[10px]"
						>{{ businessNameExist }}</span
					>
					<div
						*ngIf="!editMode"
						class="w-full max-h-[73px] p-[17px] border-solid {{
							getController('countryId').value == 103 ? 'border-b-2' : ''
						}} "
					>
						<p class="mb-0 pb-0 text-[#6E7191]">
							{{ 'ORGANIZATION.ORGANIZATION_STATUS.BUSINESS_TYPE' | translate }}
						</p>
						<p class="viewMode text-font-16">
							{{
								translate.currentLang == 'ar'
									? organizationData?.type?.name?.ar
									: organizationData?.type?.name?.en
							}}
						</p>
					</div>
					<mat-form-field
						*ngIf="editMode"
						[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
						class="w-full mb-[16px]"
						appearance="outline"
						floatLabel="always"
					>
						<mat-label class="text-dark-grey">{{
							'ORGANIZATION.ORGANIZATION_STATUS.BUSINESS_TYPE' | translate
						}}</mat-label>
						<mat-select
							formControlName="serviceProviderTypeId"
							[compareWith]="compareWith"
							required
							class="text-medium-gray px-3"
						>
							<mat-option
								class="my-2"
								*ngFor="let type of businessTypes"
								[value]="type.id"
							>
								{{
									translate.currentLang == 'en' ? type.name.en : type.name.ar
								}}
							</mat-option>
						</mat-select>
					</mat-form-field>

					<div
						*ngIf="
							getController('countryId').value == 103 &&
							getController('serviceProviderTypeId').value != 2
						"
					>
						<mat-form-field
							*ngIf="editMode"
							[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
							class="w-full mb-[16px]"
							appearance="outline"
							floatLabel="always"
						>
							<mat-label class="text-dark-grey">{{
								'ORGANIZATION.ORGANIZATION_STATUS.COMMERCIAL_REGISTRATION'
									| translate
							}}</mat-label>
							<input
								type="text"
								matInput
								class="text-[16px]"
								maxlength="10"
								minlength="10"
								placeholder="{{
									'ORGANIZATION.ORGANIZATION_STATUS.COMMERCIAL_REGISTRATION'
										| translate
								}}"
								formControlName="commercialRegistration"
							/>
							<img
								*ngIf="
									getController('commercialRegistration')?.value && editMode
								"
								(click)="getController('commercialRegistration').setValue('')"
								class="cursor-pointer absolute ltr:right-0 rtl:left-0 inline-block top-[9px]"
								src="./assets/images/close-square.svg"
								alt=""
							/>
							<mat-error>
								<validation-message
									[controller]="getController('commercialRegistration')"
									controller_name="ORGANIZATION.ORGANIZATION_STATUS.COMMERCIAL_REGISTRATION"
									pattern_Message="VALIDATION.COMMERCIAL_NOTVALID"
								>
								</validation-message>
							</mat-error>
						</mat-form-field>
						<div
							*ngIf="!editMode"
							class="w-full max-h-[73px] p-[17px] border-solid"
						>
							<p class="mb-0 pb-0 text-[#6E7191]">
								{{
									'ORGANIZATION.ORGANIZATION_STATUS.COMMERCIAL_REGISTRATION'
										| translate
								}}
							</p>
							<p class="viewMode">
								{{ organizationData?.commercialRegistration }}
							</p>
						</div>
						<img
							*ngIf="!editMode"
							[src]="
								attachmentUrl +
								'/' +
								organizationData.commercialRegisterationUrl
							"
							onerror="this.src='assets/images/empty state.jpg'"
							ca
							class="h-full w-full rounded-[12px]"
							alt=""
						/>
					</div>

					<div
						*ngIf="
							getController('countryId').value == 103 &&
							getController('serviceProviderTypeId').value == 2
						"
					>
						<mat-form-field
							*ngIf="editMode"
							[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
							class="w-full mb-[16px]"
							appearance="outline"
							floatLabel="always"
						>
							<mat-label class="text-dark-grey">{{
								'ORGANIZATION.ORGANIZATION_STATUS.MAROOF_NO' | translate
							}}</mat-label>
							<input
								type="text"
								matInput
								class="text-[16px]"
								maxlength="10"
								minlength="3"
								placeholder="{{
									'ORGANIZATION.ORGANIZATION_STATUS.MAROOF_NO' | translate
								}}"
								formControlName="maroofNumber"
							/>
							<img
								*ngIf="getController('maroofNumber')?.value && editMode"
								(click)="getController('maroofNumber').setValue('')"
								class="cursor-pointer absolute ltr:right-0 rtl:left-0 inline-block top-[9px]"
								src="./assets/images/close-square.svg"
								alt=""
							/>
							<mat-error>
								<validation-message
									[controller]="getController('maroofNumber')"
									controller_name="ORGANIZATION.ORGANIZATION_STATUS.MAROOF_NO"
									pattern_Message="VALIDATION.MAROOF_NO_NOTVALID"
								>
								</validation-message>
							</mat-error>
						</mat-form-field>
						<img
							*ngIf="!editMode"
							[src]="attachmentUrl + '/' + organizationData.maroofNumberUrl"
							onerror="this.src='assets/images/empty state.jpg'"
							class="h-full w-full rounded-[12px]"
							alt=""
							srcset=""
						/>
						<div
							*ngIf="!editMode"
							class="w-full max-h-[73px] p-[17px] border-solid border-b-2"
						>
							<p class="mb-0 pb-0 text-[#6E7191]">
								{{ 'ORGANIZATION.ORGANIZATION_STATUS.MAROOF_NO' | translate }}
							</p>
							<p class="viewMode">
								{{ organizationData?.maroofNumber }}
							</p>
						</div>
					</div>

					<div *ngIf="getController('countryId').value == 103 && editMode">
						<p class="text-main-color-black">
							{{
								(getController('serviceProviderTypeId').value != 2
									? 'ORGANIZATION.ORGANIZATION_STATUS.UPLOAD_COMM'
									: 'ORGANIZATION.ORGANIZATION_STATUS.UPLOAD_MAROOF_NO'
								) | translate
							}}
						</p>
						<div
							class="relative rounded-[12px] before:top-0 before:left-0 before:w-full before:h-full before:absolute before:bg-gray-700 before:bg-opacity-20"
						>
							<img
								class="w-full editImg"
								[src]="
									attachmentUrl +
									(getController('serviceProviderTypeId').value != 2
										? organizationData.commercialRegisterationUrl
										: organizationData.maroofNumberUrl)
								"
								onerror="this.src='assets/images/empty state.jpg'"
								alt=""
							/>
							<div
								class="flex justify-between absolute bottom-[12px] ltr:right-[12px] rtl:left-[12px]"
							>
								<div class="flex">
									<button
										(click)="
											getController('serviceProviderTypeId').value != 2
												? (organizationData.commercialRegisterationUrl = null)
												: (organizationData.maroofNumberUrl = null)
										"
										class="border border-solid border-off-white mx-2 hover:bg-gradient hover:text-off-white hover:border-none bg-off-white text-medium-gray text-center"
										mat-button
									>
										{{ 'ACTIONS.DELETE_IMG' | translate }}
									</button>
									<div class="flex">
										<button
											(click)="
												uploadImage(
													getController('serviceProviderTypeId').value != 2
														? 'commercial'
														: 'maroof'
												)
											"
											class="bg-gradient text-off-white rounded"
											mat-button
										>
											+ {{ 'ACTIONS.UPLOAD_IMG' | translate }}
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div *ngIf="editMode" class="flex justify-between">
						<div></div>
						<div class="flex mt-2">
							<button
								class="border border-solid border-[#D9DBE9] text-medium-gray hover:bg-gradient hover:text-off-white mx-2"
								mat-button
								(click)="changeEditMode(true); businessNameExist = false"
							>
								{{ 'ACTIONS.CANCEL' | translate }}
							</button>
							<button
								(click)="saveChanges()"
								[disabled]="
									orgInfoForm.invalid || !isChanged || businessNameExist
								"
								class="bg-gradient text-off-white rounded"
								mat-button
							>
								{{ 'ACTIONS.SAVE' | translate }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>
